/**
 * Shell: query client, auth, back button.
 */
import { useEffect } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter, useLocation, useNavigate } from 'react-router-dom'
import { AuthProvider, usePlatform } from '@/auth/AuthProvider'
import { CookieNotice } from '@/components/CookieNotice'
import AppRoutes from '@/routes'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
})

/** Telegram has its own back button; it should mirror the router. */
function BackButtonBridge() {
  const platform = usePlatform()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (!platform) return
    if (location.pathname === '/' || location.pathname === '/login') {
      platform.backButton.hide()
      return
    }
    platform.backButton.show(() => navigate(-1))
    return () => platform.backButton.hide()
  }, [platform, location.pathname, navigate])

  return null
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <BackButtonBridge />
          <AppRoutes />
          <CookieNotice />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  )
}
